/** The house rules, shown from the footer next to Settings. */

export const RULES: readonly string[] = ['No Auto Clickers'];

export function createRulesView(): HTMLElement {
  const body = document.createElement('div');
  body.className = 'settings__body rules';
  const list = document.createElement('ol');
  list.className = 'rules__list';
  for (const rule of RULES) {
    const item = document.createElement('li');
    item.textContent = rule;
    list.append(item);
  }
  body.append(list);
  return body;
}
